// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"fcc3cdce","312":"fff0e36d","484":"1bef058b","502":"c63ab772","551":"f08f88f6","629":"a6fc9f5f","842":"8df647c5","851":"ec3ecaab"}[chunkId] + ".chunk.js";
};